var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"academic-table"}},[_c('h3',[_vm._v(_vm._s(_vm.list.title))]),_c('table',[_c('tbody',_vm._l((_vm.list.element),function(e,index){return _c('tr',{key:index},_vm._l((e),function(i,i_index){return _c('td',{key:i_index},[_vm._v(_vm._s(i))])}),0)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }